<template>
  <div class="recharge">
      <!-- <div class="title">充值</div> -->
        <PayStatusBar v-if="status" :status="status" type="1"></PayStatusBar>
        <div class="subtitle">账号概况</div>
        <div class="subcont">
            <div class="cont">
                <span class="sicon">实时可用余额</span>
                <span class="money"><span class="smoiney">{{ groupAccountInfo && groupAccountInfo.balance}}</span>元</span>
            </div>
            <div class="cont">
                <span class="sicon">订单冻结金额
                    <el-popover
                    placement="top-start"
                    width="400"
                    trigger="hover"
                    title="冻结金额和结算时间说明"
                    content="">
                        <p>冻结金额是购买券时预留的金额，系统会在结算时间时扣除结算金额，并将剩余金额解冻到余额中，以便下次购券使用。</p>
                        <p>结算时间的计算方法为：发券截止时间 + 发券后有效期 + 10天。例如，如果购券订单的发券时间为2023/01/01-2023/03/01，发券后7天过期，则券的结算时间为2023/03/01 + 7 + 10 = 2023/03/18。</p>
                        <i slot="reference" class="el-icon-question"></i>
                    </el-popover>
                </span>
                <span class="money"><span class="dmoiney">{{groupAccountInfo &&  groupAccountInfo.freeze}}</span>元</span>
            </div>
        </div>
        <div v-if="isOldGroup">
            <p class="oldGroupTips">
                滴滴出行券平台服务主体现已由“滴滴出行科技有限公司”变更为“北京桔财动力科技有限公司”。变更前的充值、开票、余额，您可至原先工作台进行查看并使用，或进行退款操作，原工作台的充值余额，继续开具“滴滴出行”发票。即日起充值或开票，均由“桔财动力”提供服务，您可至对应的“桔财动力”后缀的后台进行查看并使用。
            </p>
        </div>
        <div v-else>
            
            <div class="info-wrap">
                <div class="item">
                    <label>公司名称</label>
                    <span class="msg">{{$store.state.header.userInfo.companyName}}</span>
                </div>
                <div class="item">
                    <label>工作台名称</label>
                    <span class="msg">{{$store.state.header.selfGroup.groupName}}</span>
                </div>
                <div class="item">
                    <label>充值金额</label>
                    <span class="msg">
                        <el-input
                            class="input"
                            v-model="inputValue"
                            placeholder="请输入充值金额"
                            v-bind:class="{ 'inputError': inputError}"
                            @input="inputChange"
                        ></el-input>
                        <span class="hint">元</span>
                        <span class="error" v-if="inputError">{{inputError===1? '请输入数字' : inputError===2 ? '充值金额不能包含小数' :  inputError===3 ? '请输入充值金额' :'单笔充值不能超过一百万'}}</span>
                    </span>
                </div>
            </div>
            <div class="dopay">
                <div class="item">
                    <label>选择支付方式</label>
                    <!-- <div class="paymsg" @click="choosePayType(0)"
                    v-bind:class="{ paychoosed: !payType}"
                    >
                        <span class="weixin_icon"></span>
                    微信支付
                        <span v-if="!payType" class="chooseicon"></span>
                    </div> -->
                    <div class="paymsg" @click="choosePayType(1)"
                    v-bind:class="{ paychoosed: payType===1 }"
                    >
                        <span class="ali_icon"></span>
                    支付宝
                        <span  v-if="payType===1" class="chooseicon"></span>
                    </div>
                    <div class="paymsg" @click="choosePayType(2)"
                    v-bind:class="{ paychoosed: payType===2}"
                    >
                        <span class="xianxia_icon"></span>
                    线下付款
                        <span  v-if="payType===2" class="chooseicon"></span>
                    </div>
                    <div style="color: red;font-size:14px; margin-left: 102px; margin-top: 5px;">注意：出行券账户用于购买出行券，暂不支持企业支付用车</div>
                </div>
            </div>
            <el-button style="margin-left: 158px;" class="bot" type="primary" v-if="payType!==2" @click="goPay">立即充值</el-button>
            <div class="offline"
                v-if="payType==2"
            >
                <div class="offtitle">汇款须知</div>
                <div class="offhint">1.  因线下汇款方式到账时间会有延误，强烈建议采用微信、支付宝、在线支付。</div>
                <div class="offhint">2. 汇款金额<span>1000元</span>起。</div>
                <div class="offhint">3. 该账号是您专属的收款账号，系统将在您汇款后1小时内将款项自动充值到您的滴滴工作台账户。</div>
                <div class="offhint">4. 如果打款系统无法识别极速收款账号，您仍可使用普通收款账号进行汇款。</div>
                <div class="offtitle">收款信息</div>
                <table class="offtable">
                    <tr>
                        <td>收款银行</td>
                        <td>招商银行股份有限公司北京东三环支行</td>
                        </tr>
                    <tr>
                        <td>收款账号</td>
                        <td>{{$store.state.header.selfGroup.virtualAccountId}}</td>
                    </tr>
                    <tr>
                        <td>开户名称</td>
                        <td>北京桔财动力科技有限公司</td>
                    </tr>
                </table>
                <!-- <div class="offa" @click="goShowOffmodal">查看普通汇款账号</div> -->
            </div>
            <PayModal v-if="showModal"
                :showModal="showModal"
                :payType="payType"
                :type="0"
                :amount="inputValue"
                @close="closePayModal"
            ></PayModal>
            <el-dialog
            v-if="showOffModal"
            :visible.sync="showOffModal"
            width="30%"
            top="35px"
            center>
            <div class="offline modaloff">
                <div class="offtitle">汇款须知</div>
                <div class="offhint">1. 汇款金额<span>1000元</span>起。</div>
                <div class="offhint">2. 线下汇款方式到账时间有延误，优先建议采用微信、支付宝支付。</div>
                <div class="offhint">3. 采用线下汇款方式，完成汇款后，请您点击下方【确认并下载邮件模版】按钮，填写模版内容，发送至企业级服务中心邮箱<span>payment_centre@didichuxing.com</span>，我们会在收到邮件且款项到账后的1-2个工作日内完成充值。</div>
                <table class="offtable">
                    <tr>
                        <td>收款银行</td>
                        <td>招商银行股份有限公司北京东三环支行</td>
                        </tr>
                    <tr>
                        <td>收款账号</td>
                        <td>122905939910108</td>
                    </tr>
                    <tr>
                        <td>开户名称</td>
                        <td>滴滴出行科技有限公司</td>
                    </tr>
                </table>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="downloadEmailModel">确认并下载邮件模板</el-button>
            </span>
            </el-dialog>
        </div>
        
  </div>
</template>
<script>
import {mapState, mapActions} from 'vuex'
import PayModal from 'Components/PayModal.vue'
import PayStatusBar from '../purchaseCoupon/components/PayStatusBar.vue'

export default {
  name: 'recharge',
  data () {
    return {
      showModal: false,
      payStatus: 0,
      payType: 1, // 0微信，1支付宝
      inputValue: '',
      inputError: false,
      status: 0, // 充值结果
      showOffModal: false
    //   virtualAccountId: this.$store.state.header.selfGroup.virtualAccountId
    }
  },
  created () {
    this.getgroupAccountInfo()
    // this.omgTrack('es_chuxingquan_xieyi_invoice_sw', '出行券模块打开发票信息页面')
    this.omgTrack('es_chuxingquan_xieyi_finan_sw', '出行券模块打开财务信息页面')
  },
  components: {PayModal, PayStatusBar},
  computed: {
    isOldGroup:function(){
		console.log(this.$store.state.header.selfGroup.version)
		return this.$store.state.header.selfGroup.version == 0 ? true :false
	},
    ...mapState('recharge', ['groupAccountInfo'])
    // ...mapGetters('header',['selfGroup'])
  },
  methods: {
    ...mapActions('recharge', ['getgroupAccountInfo', 'downloadTemplate']),
    ...mapActions('couponPay', ['stopPolling']),
    choosePayType (type) { // 选择支付方式
      this.payType = type
    },
    goPay () { // 确认支付按钮
    //   if (!/^(?:0|[1-9]\d*)(?:\.\d*[1-9])?$/.test(this.inputValue)) {
    //     this.inputError = 1
    //   } else if (!/^[0-9]*$/.test(this.inputValue)) {
    //     this.inputError = 2
    //   } else {
    //     this.inputError = false
    //     this.showModal = true
    //   }
      // reset state fix by limeng
      this.status = 0
      if (!this.inputValue) {
        this.inputError = 3
      } else if (!this.inputError && this.inputValue) {
        this.showModal = true
      }
    },
    closePayModal (status) { // 关闭支付弹窗
      this.showModal = false
      // 如果还在轮询停止轮询
      this.stopPolling()
      this.status = status
      if (status === 1) { // 充值成功
        this.getgroupAccountInfo()
        this.inputValue = ''
      }
    },
    inputChange (value) {
      if (!this.inputValue) { // 为空
        this.inputError = 3
      } else if (!/^(?:0|[1-9]\d*)(?:\.\d*[1-9])?$/.test(this.inputValue)) { // 数字
        this.inputError = 1
      } else if (!/^[0-9]*$/.test(this.inputValue)) { // 无小数
        this.inputError = 2
      } else if (Number(this.inputValue) > 1000000) { // 大于100万
        this.inputError = 4
      } else {
        this.inputError = false
      }
    },
    goShowOffmodal () { // 显示汇款须知
      this.showOffModal = true
    },
    downloadEmailModel () { // 关闭汇款须知
      // todo下载
      this.showOffModal = false
      // window.location.href=''
      this.downloadTemplate({
        groupId: this.$store.state.header.selfGroup.groupId
      })
    }
  }
}
</script>
<style  lang="stylus">
    .recharge{
        .title{
            color: #333;
            font-size: 20px;
            padding-left: 20px;
            height:68px;
            line-height:68px;
            border-bottom: solid 1px #E5E5E5;
        }
        .info-wrap{
            padding-left: 30px;
        }
        .oldGroupTips{
            font-size: 14px;
            line-height: 24px;
            width: 500px;
            padding: 40px;
            text-indent: 2em;
        }
        .item{
            position: relative;
            margin-top: 28px;
            margin-left: 27px;
            label{
                width: 84px;
                display: inline-block;
                text-align: right;
                font-size:14px;
                color: #666;
                margin-right: 20px;
            }
            .msg{
                color: #333;
                font-size: 14px;
                .detailmsg{
                    font-size: 12px;
                    color: #999;
                }
                .hint{
                    position: relative;
                    left: -25px;
                    font-size: 14px;
                    color: #999999;
                }
                .error{
                    color:red
                    font-size: 14px;
                }
                .input{
                    display: inline-block;
                    width: 180px;
                    height: 36px;
                }
                .inputError .el-input__inner{
                        border: solid 1px #f00;
                }
                .inputError .el-input.is-active .el-input__inner, inputError.el-input__inner:focus{
                        border: solid 1px #f00;
                }
            }

        }
        .dopay{
            margin-left: 30px;
            padding-top:10px;
            height: 150px;
            label{
                position: relative;
                top: -23px;
            }
            .paymsg{
                position: relative;
                display: inline-block;
                width: 160px;
                height: 70px;
                margin-right: 20px;
                border: 1px solid #E0E0E0;
                line-height: 70px;
                text-align: center;
                font-size:18px;
                color:#333;
            }
            .weixin_icon{
                width: 24px;
                height: 24px;
                background: url('../../images/pay_weipay.png');
                background-size: 100% auto;
                display: inline-block;
                position: relative;
                top: 5px;
            }
            .ali_icon{
                width: 24px;
                height: 24px;
                background: url('../../images/pay_alipay.png');
                background-size: 100% auto;
                display: inline-block;
                position: relative;
                top: 5px;
            }
            .xianxia_icon{
                width: 24px;
                height: 24px;
                background: url('../../images/pay_xianxia.png');
                background-size: 100% auto;
                display: inline-block;
                position: relative;
                top: 5px;
            }
            .paychoosed{
                border: 1px solid #3468FF;
            }
            .chooseicon{
                width: 30px;
                height: 30px;
                background: url('../../images/check.png');
                background-size: 100% auto;
                display: inline-block;
                position: absolute;
                left: 131px;
                top: 40px;
            }
        }
        .bot{
            margin-left: 116px;
            margin-bottom:40px;
        }
        .inputError .el-input__inner{
                border: solid 1px #f00;
        }
        .offline{
            margin-left:160px;
            margin-top:-20px;
            .offtitle{
                font-size:16px;
                font-weight:bold;
                color:#333;
                margin-bottom:20px;
                margin-top:20px;
            }
            .offhint{
                font-size:14px;
                color:#666;
                margin-bottom:10px;
            }
            .offtable{
                margin-bottom: 20px;
                border-collapse: collapse;
                tr{
                    height: 50px;
                    line-height: 50px;
                }
                td{
                    text-align: center;
                    font-size:14px;
                    color:#666;
                    border: solid 1px #e5e5e5;
                }
                td:nth-child(odd){
                    width:116px;
                }
                td:nth-child(even){
                    width:361px;
                }
            }
            .offa{
                font-size: 14px;
                color: #3468FF;
                margin-bottom:30px;
                cursor: pointer;
            }
        }
        .modaloff{
            margin-left:0px;
            padding-top:-10px;
            .offtitle{
                font-size:20px;
                margin-bottom:40px;
            }
        }
        .subtitle{
            margin:20px 0 40px 20px;
            color:#333;
            font-size:16px;
        }
        .subcont{
            margin-left:40px
            padding-bottom:40px;
            border-bottom: solid 1px  #e5e5e5;
            .cont{
                display:inline-block;
                width:300px;
            }
            .sicon{
                display:block;
                background: url('../../images/ic_money.png')
                background-size: 6% auto;
                background-repeat: no-repeat;
                padding-left: 24px;
                font-size: 14px;
                color: #333;
                margin-bottom:11px;
                i{
                    color :#ccc;
                    font-size:16px;
                }
            }
            .smoiney{
                font-size:32px;
                color: #333;
                 margin-right:5px;
            }
            .dmoiney{
                font-size:32px
                color: 32px;
                 margin-right:5px;
            }
            .money{
                color:#333;
            }
        }
    }
</style>
